export const csrfToken = () => {
  const metaEl = document.querySelector(`meta[name='csrf-token']`)
  return metaEl?.content
}

